import CrmServiceModel from "@/models/CrmServiceModel";
import CustomerContactCollection from "@/collections/crm/CustomerContactCollection";
import CustomerLocationCollection from "@/collections/crm/CustomerLocationCollection";
import CustomerContactModel from "./CustomerContactModel";
import CustomerLocationModel from "./CustomerLocationModel";
import ProjectModel from "@/models/lab/ProjectModel";
import ProjectCollection from "@/collections/lab/ProjectCollection";

export default class CustomerModel extends CrmServiceModel {
  modelName() {
    return 'customers';
  }
  icon() {
    return 'user';
  }
  defaults() {
    return {
      id: null,
      short_name: null,
      full_name: null,
      account_number: null,
      inactive: false,
      credit: false,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      customer_contacts: [],
      customer_locations: []
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      short_name: (val) => (this.nullStringMutator(val)),
      full_name: (val) => (this.nullStringMutator(val)),
      account_number: (val) => (this.nullStringMutator(val)),
      inactive: (val) => val,
      credit: (val) => val,
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getCustomerContacts() {
    return this.getRelatedCollection(new CustomerContactCollection(), 'customer_contacts');
  }
  getCustomerLocations() {
    return this.getRelatedCollection(new CustomerLocationCollection(), 'customer_locations');
  }
  getPrimaryCustomerContact() {
    return this.getRelatedModel(CustomerContactModel, 'primary_customer_contact');
  }
  getPrimaryBillingLocation() {
    return this.getRelatedModel(CustomerLocationModel, 'primary_billing_location');
  }
  getPrimaryShippingLocation() {
    return this.getRelatedModel(CustomerLocationModel, 'primary_shipping_location');
  }
  getLastProject() {
    const collection = new ProjectCollection();
    let model = new ProjectModel();

    collection.getFilter().filterEquals('customer_id', this.id);
    collection.getFilter().sortAddDesc('created_at');
    collection.fetch().then(() => {
      if(collection.count()) {
        model = collection.first();
      }
    });
    
    return model;
  }
}
